import { SENSITIVE_URL_PARAMS } from '@web/common/url'

/**
 * Скрывает в событиях Sentry значения токена входа и идентичности посетителя.
 * Хлебные крошки и транзакции несут полные адреса запросов и переходов
 * (`/order/1?token=<JWT>`, mp4 с `?token=`), а адрес может стоять и внутри
 * текста (описание span «GET /p?…»). Поэтому ищем пары `?имя=` / `&имя=` в любой
 * строке и заменяем значение на [Filtered] (MOB-586).
 */
const SENSITIVE_PAIR = new RegExp(`([?&](?:${SENSITIVE_URL_PARAMS.join('|')})=)[^&#\\s"']*`, 'g')
// Тот же адрес, закодированный в значении параметра (`?returnUrl=%2Fp%3Ftoken%3D…`).
const ENCODED_SENSITIVE_PAIR = new RegExp(`((?:%3F|%26)(?:${SENSITIVE_URL_PARAMS.join('|')})%3D)(?:(?!%26)[^&#\\s"'])*`, 'gi')
const FILTERED = '[Filtered]'

function scrubString (value: string): string {
  return value.includes('=')
    ? value.replace(SENSITIVE_PAIR, `$1${FILTERED}`).replace(ENCODED_SENSITIVE_PAIR, `$1${FILTERED}`)
    : value
}

export function scrubSensitiveParams<T> (value: T, seen: WeakSet<object> = new WeakSet()): T {
  if (typeof value === 'string') {
    return scrubString(value) as unknown as T
  }
  if (!value || typeof value !== 'object') {
    return value
  }
  if (seen.has(value as unknown as object)) {
    return value
  }
  seen.add(value as unknown as object)

  if (Array.isArray(value)) {
    return value.map(item => scrubSensitiveParams(item, seen)) as unknown as T
  }
  // Только простые объекты: экземпляры классов (Date, Error и т. п.) не пересобираем.
  const proto = Object.getPrototypeOf(value)
  if (proto !== Object.prototype && proto !== null) {
    return value
  }
  const result: Record<string, unknown> = {}
  Object.entries(value as Record<string, unknown>).forEach(([key, item]) => {
    result[key] = scrubSensitiveParams(item, seen)
  })
  return result as T
}
